<template>
  <div class="audit-container">
    <!-- 顶部导航栏 -->
    <div class="page-header">
      <div class="header-content">
        <div class="header-left">
          <el-button @click="$router.back()" size="small">
            <i class="el-icon-arrow-left"></i>返回
          </el-button>
          <h2 class="page-title">订单审核</h2>
        </div>
        <div class="header-center">
          订单号：{{ order.orderSn }}
        </div>
        <div class="header-right">
          <el-tag :type="getOrderStateTagType(order.orderState)" size="medium">
            {{ getOrderStateName(order.orderState) }}
          </el-tag>
        </div>
      </div>
    </div>

    <div class="content-wrapper">
      <!-- 核心信息概览 -->
      <div class="overview-section">
        <div class="overview-item">
          <div class="item-label">订单金额</div>
          <div class="item-value amount">￥{{ order.orderAmount }}</div>
        </div>
        <div class="overview-item">
          <div class="item-label">创建时间</div>
          <div class="item-value">{{ order.createTime }}</div>
        </div>
        <div class="overview-item">
          <div class="item-label">客户名称</div>
          <div class="item-value">{{ order.customer.customerName }}</div>
        </div>
        <div class="overview-item">
          <div class="item-label">支付状态</div>
          <div class="item-value">
            <el-tag :type="getPaymentTagType(order.paymentStatus)" size="small">
              {{ order.paymentStatus }}
            </el-tag>
          </div>
        </div>
        <div class="overview-item">
          <div class="item-label">操作员</div>
          <div class="item-value">{{ order.employee.adminName }}</div>
        </div>
      </div>

      <div class="main-content">
        <!-- 左侧信息区域 -->
        <div class="info-section">
          <!-- 客户与发货信息 -->
          <el-card class="info-card" shadow="never">
            <div slot="header" class="card-header">
              <i class="el-icon-user"></i>
              <span>客户与发货信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="16">
                <el-col :span="12">
                  <div class="info-item">
                    <span class="info-label">客户名称：</span>
                    <span class="info-value">{{ order.customer.customerName }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="info-item">
                    <span class="info-label">联系方式：</span>
                    <span class="info-value" @click="copyToClipboard(order.customer.phoneNumber)">
                      {{ order.customer.phoneNumber }}
                      <i class="el-icon-document-copy copy-icon"></i>
                    </span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="info-item">
                    <span class="info-label">销售渠道：</span>
                    <span class="info-value">{{ gettypeNameById(order.customer.typeId) }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="info-item">
                    <span class="info-label">客户级别：</span>
                    <span class="info-value">{{ getlabelNameById(order.customer.labelId) }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="info-item">
                    <span class="info-label">客户来源：</span>
                    <span class="info-value">{{ getsourceNameById(order.customer.sourceId) }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="info-item">
                    <span class="info-label">发货方式：</span>
                    <span class="info-value">{{ order.logisticsMethods }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="info-item">
                    <span class="info-label">快递公司：</span>
                    <span class="info-value">{{ order.logisticsCompanies }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="info-item">
                    <span class="info-label">快递单号：</span>
                    <span class="info-value" @click="copyToClipboard(order.trackingNumber)">
                      {{ order.trackingNumber }}
                      <i class="el-icon-document-copy copy-icon"></i>
                    </span>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="info-item full">
                    <span class="info-label">收货地址：</span>
                    <span class="info-value">{{ order.shippingAddress }}</span>
                  </div>
                </el-col>
                <el-col :span="24" v-if="order.remarks">
                  <div class="info-item full">
                    <span class="info-label">快递备注：</span>
                    <span class="info-value">{{ order.remarks }}</span>
                  </div>
                </el-col>
                <el-col :span="24" v-if="order.notes">
                  <div class="info-item full">
                    <span class="info-label">订单备注：</span>
                    <span class="info-value">{{ order.notes }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>

          <!-- 产品信息 -->
          <el-card class="info-card" shadow="never">
            <div slot="header" class="card-header">
              <i class="el-icon-goods"></i>
              <span>产品信息</span>
            </div>
            <div class="card-body">
              <el-table
                :data="productList"
                style="width: 100%"
                border
                size="small"
                :empty-text="'暂无产品'"
                v-loading="loading"
                element-loading-text="加载中..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                class="product-table"
              >
                <el-table-column prop="productName" label="产品名称" :align="'left'" show-overflow-tooltip></el-table-column>
                <el-table-column prop="picture" label="产品图片" :align="'center'" width="80">
                  <template slot-scope="scope">
                    <el-image
                      style="width: 50px; height: 50px;"
                      :src="scope.row.picture"
                      :preview-src-list="[scope.row.picture]"
                      alt="产品图片"
                      fit="cover"
                      lazy
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="产品价格" :align="'right'" width="90"></el-table-column>
                <el-table-column prop="costPrice" label="售价" :align="'right'" width="80"></el-table-column>
                <el-table-column prop="orderNum" label="数量" :align="'center'" width="70"></el-table-column>
                <el-table-column prop="salePrice" label="成交价" :align="'right'" width="80"></el-table-column>
                <el-table-column prop="orderAmount" label="金额" :align="'right'" width="90"></el-table-column>
              </el-table>
              <div class="table-summary">
                <div class="summary-item">
                  <span>总数量: <b>{{ totalOrderNum }}</b> 箱</span>
                </div>
                <div class="summary-item primary">
                  <span>订单总金额: <b>￥{{ totalOrderAmount }}</b></span>
                </div>
              </div>
            </div>
          </el-card>

          <!-- 回款信息 -->
          <el-card class="info-card" shadow="never">
            <div slot="header" class="card-header">
              <i class="el-icon-bank-card"></i>
              <span>回款信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="16">
                <el-col :span="12">
                  <div class="info-item">
                    <span class="info-label">支付方式：</span>
                    <span class="info-value">{{ order.payType }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="info-item">
                    <span class="info-label">支付状态：</span>
                    <span class="info-value">
                      <el-tag :type="getPaymentTagType(order.paymentStatus)" size="small">
                        {{ order.paymentStatus }}
                      </el-tag>
                    </span>
                  </div>
                </el-col>
                <el-col :span="24" v-if="order.remarks">
                  <div class="info-item full">
                    <span class="info-label">收款备注：</span>
                    <span class="info-value">{{ order.remarks }}</span>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="info-item full">
                    <span class="info-label">收款凭证：</span>
                    <div class="receipt-container">
                      <div class="receipt-row" v-if="order.receipt && order.receipt.length > 0">
                        <el-image
                          v-for="(url, index) in order.receipt"
                          :key="index"
                          :src="url"
                          :preview-src-list="order.receipt"
                          :z-index="2000"
                          class="receipt-thumb"
                          fit="cover"
                          lazy
                        />
                      </div>
                      <div v-else class="no-images-message">
                        暂无收款凭证
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>

        <!-- 右侧操作区域 -->
        <div class="action-section">
          <!-- 审核操作 -->
          <el-card class="audit-card" shadow="never">
            <div slot="header" class="card-header">
              <i class="el-icon-edit"></i>
              <span>审核操作</span>
            </div>
            <div class="card-body">
              <el-form
                :model="orderExamine"
                label-width="80px"
                ref="orderExamine"
                :rules="orderExamineRules"
                :validate-on-rule-change="false"
                size="small"
              >
                <el-form-item prop="findingOfAudit" label="审核结果">
                  <el-radio-group v-model="orderExamine.findingOfAudit" class="radio-group">
                    <el-radio :label="1" border>审核通过</el-radio>
                    <el-radio :label="2" border>拒绝</el-radio>
                  </el-radio-group>
                </el-form-item>

                <div v-if="orderExamine.findingOfAudit === 1">
                  <el-form-item
                    label="复审人"
                    v-if="order.orderState === 0"
                    prop="intermediateReviewer"
                  >
                    <el-select
                      v-model="orderExamine.intermediateReviewer"
                      placeholder="请选择复审人"
                      filterable
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in examines"
                        :key="item.id"
                        :label="item.adminName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label="终审人"
                    v-if="order.orderState === 1"
                    prop="finalReviewer"
                  >
                    <el-select
                      v-model="orderExamine.finalReviewer"
                      placeholder="请选择终审人"
                      filterable
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in examines"
                        :key="item.id"
                        :label="item.adminName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label="初审意见"
                    v-if="order.orderState === 0"
                    prop="juniorReviewerNotes"
                  >
                    <el-input
                      v-model="orderExamine.juniorReviewerNotes"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入初审意见..."
                      resize="vertical"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="复审意见"
                    v-if="order.orderState === 1"
                    prop="intermediateReviewerNotes"
                  >
                    <el-input
                      v-model="orderExamine.intermediateReviewerNotes"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入复审意见..."
                      resize="vertical"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="终审意见"
                    v-if="order.orderState === 7"
                    prop="finalReviewerNotes"
                  >
                    <el-input
                      v-model="orderExamine.finalReviewerNotes"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入终审意见..."
                      resize="vertical"
                    ></el-input>
                  </el-form-item>
                </div>

                <el-form-item
                  label="拒绝原因"
                  v-if="orderExamine.findingOfAudit === 2"
                  prop="refuse"
                >
                  <el-input
                    v-model="orderExamine.refuse"
                    type="textarea"
                    :rows="4"
                    placeholder="请输入详细拒绝理由，便于再次修改..."
                    resize="vertical"
                  ></el-input>
                </el-form-item>

                <div class="form-actions-wrapper">
                  <el-form-item class="form-actions">
                    <el-button @click="$router.back()">取消</el-button>
                    <el-button type="primary" @click="examineOrder" :loading="formLoading">提交审核</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </el-card>

          <!-- 审核记录 -->
          <el-card class="timeline-card" shadow="never">
  <div slot="header" class="card-header">
    <i class="el-icon-time"></i>
    <span>审核记录</span>
  </div>
  <div class="card-body timeline-body">
    <el-timeline :reverse="false" class="audit-timeline">
      <el-timeline-item
        v-for="(item, index) in orderTimeList"
        :key="index"
        :color="getColor(item, index)"
        :line-style="{borderWidth: '1px'}"
        size="normal"
        class="timeline-item"
      >
        <div class="timeline-item-wrapper">
          <div class="timeline-item-header">
            <span class="timeline-time">{{ item.time }}</span>
            <el-tag
              :type="getTagType(item, index)"
              size="mini"
              class="timeline-tag"
            >
              {{ item.operateType }}
            </el-tag>
          </div>
          <div class="timeline-content">
            {{ item.content }}
          </div>
        </div>
      </el-timeline-item>
    </el-timeline>
    <div v-if="!orderTimeList || orderTimeList.length === 0" class="empty-timeline">
      <i class="el-icon-info"></i>
      <span>暂无审核记录</span>
    </div>
  </div>
</el-card>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'examine',
  data() {
    return {
      loading: false,
      formLoading: false,
      showLargeImage: false,
      order: {
        employee: {},
        customer:{},
        orderDetail:{},
        receipt:[],
      },
      //订单审核进度
      orderStep: [],
      orderExamine:{
        findingOfAudit: 1
      },
      //时间线组件
      orderTimeList:[],
      //还款记录组件
      repayTimeList:[],
      reverse:false,
      examines:[],//审核人列表
      // 客户级别
      custoLabel: [],
      // 客户销售渠道
      custoType: [],
      //客户来源
      custoSource: [],
      productList: [],
      orderReviewer: [],
      selectedAuditor: null, // 选中的审核人
      auditComment: '', // 审核备注
      totalOrderNum: 0, // 总选购数量
      totalOrderAmount: 0, // 总金额
    };
  },

  computed: {
    orderExamineRules() {
      let rules = {
        findingOfAudit: [
          { required: true, message: '请选择审核结果', trigger: 'change' }
        ]
      };

      if (this.orderExamine.findingOfAudit === 2) {
        // 如果选择了拒绝，则添加拒绝理由的校验规则
        rules.refuse = [
          { required: true, message: '请输入详细拒绝理由，便于再次修改', trigger: 'blur' }
        ];
      } else {
        switch (this.order.orderState) {
          case 0:
            rules.intermediateReviewer = [
              { required: true, message: '请选择复审人', trigger: 'blur' }
            ];
            rules.juniorReviewerNotes = [
              { required: true, message: '请输入初审意见', trigger: 'blur' }
            ];
            break;
          case 1:
            rules.finalReviewer = [
              { required: true, message: '请选择终审人', trigger: 'blur' }
            ];
            rules.intermediateReviewerNotes = [
              { required: true, message: '请输入复审意见', trigger: 'blur' }
            ];
            break;
          case 7:
            rules.finalReviewerNotes = [
              { required: true, message: '请输入终审意见', trigger: 'blur' }
            ];
            break;
        }
      }

      return rules;
    }
  },

  created() {
    this.initData();
  },

  methods: {
    initData() {
      this.loading = true;
      Promise.all([
        this.fetchOrderDetail(),
        this.getSerouce(),
        this.getType(),
        this.getLabel(),
        this.getOrderReviewer(),
        this.findExamine()
      ]).finally(() => {
        this.loading = false;
      });
    },


    // 订单状态名称映射
    getOrderStateName(state) {
      switch (state) {
        case 0:
          return '待审核';
        case 1:
          return '待复审';
        case 2:
          return '审核未通过';
        case 3:
          return '待发货';
        case 4:
          return '已发货';
        case 5:
          return '交易成功';
        case 6:
          return '订单取消';
        case 7:
          return '待终审';
        default:
          return '';
      }
    },

    // 复制文本到剪贴板
    copyToClipboard(text) {
      if (!text) return;

      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        this.$message({
          message: '复制成功',
          type: 'success',
          duration: 1000
        });
      } catch (err) {
        this.$message({
          message: '复制失败',
          type: 'error',
          duration: 1000
        });
      }

      document.body.removeChild(textArea);
    },

    // 表格行样式
    tableRowClassName({row, rowIndex}) {
      return 'table-row-hover';
    },

    // 订单状态标签类型
    getOrderStateTagType(state) {
      switch (state) {
        case 0:
          return 'primary'; // 待审核
        case 1:
          return 'warning'; // 待复审
        case 2:
          return 'danger'; // 审核未通过
        case 3:
          return 'info'; // 待发货
        case 4:
          return 'info'; // 已发货
        case 5:
          return 'success'; // 交易成功
        case 6:
          return 'danger'; // 订单取消
        case 7:
          return 'warning'; // 待终审
        default:
          return 'default';
      }
    },

    // 支付状态标签类型
    getPaymentTagType(status) {
      if (status === '还款完成') return 'success';
      if (status === '部分还款') return 'warning';
      if (status === '欠款') return 'danger';
      return 'info';
    },
    //查询审核人有哪些
    findExamine() {
      this.$http.get('employee/examine').then(res => {
        this.examines = res.data;
      })
    },
    fetchOrderDetail() {
      const orderSn = this.$route.params.orderSn; // 获取路由参数或 props
      if (orderSn) {
        this.$http.get(`/orderList/${orderSn}`)
            .then(response => {
              const data = response.data;
              if (data) {
                this.order = {
                  ...data,
                  receipt: data.receipt ? data.receipt.split(',') : [],
                  voucher: data.voucher ? data.voucher.split(',') : []
                };
                if (['欠款', '部分还款', '还款完成'].includes(this.order.paymentStatus)) {
                  this.getOrderRepaymentTime(); // 调用获取还款信息的方法
                }
              } else {
                console.error('Invalid response data structure');
                this.order = {}; // 或者设置为默认值
              }
            })
            .catch(error => {
              console.error('获取订单详情失败:', error);
            });
        //获取订单产品
        this.$http.post("/orderProducid/" + orderSn).then(res => {
          this.productList = res.data;
          this.calculateTotals(); // 数据加载完成后计算统计值
        });
        this.$http.post("/orderTime/" + orderSn).then(res => {
          const data = res.data;
          // 确保格式化每个时间项
          this.orderTimeList = data.map(item => ({
            ...item,
            time: this.$formatTimeNew(item.time)
          }));
        });
      }
    },
    calculateTotals() {
      this.totalOrderNum = this.productList.reduce(
          (sum, product) => sum + (product.orderNum || 0),
          0
      );
      this.totalOrderAmount = this.productList.reduce(
          (sum, product) => sum + (product.orderAmount || 0),
          0
      ).toFixed(2); // 保留两位小数
    },
    getOrderRepaymentTime() {
      const orderSn = this.$route.params.orderSn; // 获取路由参数或 props
      this.$http.post("/orderRepayment/" + orderSn).then(res => {
        const data = res.data;
        // 确保格式化每个时间项
        this.repayTimeList = data.map(item => ({
          ...item,
          time: this.$formatTimeNew(item.repaymentTime)
        }));
      });
    },
//根据内容显示动态的图标
    getColor(item, index) {
      if (index === 0) {
        return "#409eff";
      } else if (
          item.content.includes("订单审核未通过") ||
          item.content.includes("订单取消")
      ) {
        return "#F56C6C";
      } else {
        return "#67C23A";
      }
    },
    getrePayColor(item, index) {
      if (index === 0) {
        return "#409eff"; // 默认颜色，当前项高亮为蓝色
      } else if (item.style.includes("部分还款")) {
        return "#E6A23C"; // 蓝色，用于部分还款
      } else if (item.style.includes("欠款")) {
        return "#F56C6C"; // 黄色，用于欠款
      } else if (item.style.includes("还款完成")) {
        return "#67C23A"; // 绿色，用于欠款完成
      } else {
        return "#909399"; // 默认灰色，适用于其他情况
      }
    },
    getTagType(item, index) {
      if (index === 0) {
        return "primary"; // 默认类型（无样式）
      } else if (
          item.content.includes("订单审核未通过") ||
          item.content.includes("订单取消")
      ) {
        return "danger"; // 红色类型
      } else {
        return "success"; // 绿色类型
      }
    },
    getrePayTagType(item, index) {
      if (index === 0) {
        return "primary"; // 默认类型（无样式）
      } else if (item.style.includes("部分还款")) {
        return "warning"; // 蓝色类型
      } else if (item.style.includes("欠款")) {
        return "danger"; // 黄色类型
      } else if (item.style.includes("还款完成")) {
        return "success"; // 绿色类型
      } else {
        return ""; // 默认类型
      }
    },
    //获取客户数据信息
    gettypeNameById(typeId) {
      const category = this.custoType.find(item => item.id === typeId);
      return category ? category.customerType : '';
    },
    getlabelNameById(labelId) {
      const category = this.custoLabel.find(item => item.id === labelId);
      return category ? category.customerLabel : '';
    },
    getsourceNameById(sourceId) {
      const category = this.custoSource.find(item => item.id === sourceId);
      return category ? category.customerSource : '';
    },
    getReviewerNameById(reviewerKey) {
      const reviewer = this.orderReviewer.find(item => item.id === reviewerKey);
      return reviewer ? reviewer.adminName : '';
    },
    //获取类型
    getType() {
      this.$http.get("/customerType").then(res => {
        this.custoType = res.data;
      })
    },
    //获取标签
    getLabel() {
      this.$http.get("/customerLabel").then(res => {
        this.custoLabel = res.data;
      })
    },
    //获取来源
    getSerouce() {
      this.$http.get("/customerSource").then(res => {
        this.custoSource = res.data;
      })
    },
    //获取审核人
    getOrderReviewer() {
      this.$http.get("/employee").then(res => {
        this.orderReviewer = res.data;
      });
    },

    examineOrder() {
      this.$refs['orderExamine'].validate(valid => {
        if (valid) {
          this.$confirm('确认提交审核结果？提交后不可更改', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.formLoading = true;
            let para = Object.assign({}, this.orderExamine);
            para.orderSn = this.$route.params.orderSn;
            para.orderState = this.order.orderState;
            this.$http.put("/orderList/Examine", para).then(res => {
              if (res.data.success) {
                this.$message({
                  message: '提交成功',
                  type: 'success',
                  duration: 1500
                });
                this.$refs['orderExamine'].resetFields();
                this.$router.back();
              } else {
                this.$message.error("提交失败，请重试");
              }
              this.formLoading = false;
            }).catch(() => {
              this.$message.error("系统错误，请重试");
              this.formLoading = false;
            });
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.audit-container {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding: 0;
}

.page-header {
  background-color: #fff;
  border-bottom: 1px solid #ebeef5;
  padding: 0 24px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  max-width: 1600px;
  margin: 0 auto;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-center {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.content-wrapper {
  padding: 20px;
  max-width: 1600px;
  margin: 0 auto;
}

/* 概览样式 */
.overview-section {
  display: flex;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 16px 24px;
  gap: 32px;
}

.overview-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.item-label {
  font-size: 12px;
  color: #909399;
}

.item-value {
  font-size: 14px;
  color: #303133;
  position: relative;
  cursor: pointer;
}

.item-value.amount {
  font-size: 18px;
  font-weight: 600;
  color: #f56c6c;
}

.main-content {
  display: flex;
  gap: 20px;
}

.info-section {
  flex: 3;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.action-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 400px;
}

/* 卡片样式 */
.info-card, .audit-card, .timeline-card {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fff;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  padding: 14px 20px;
  background-color: #fafafa;
  border-bottom: 1px solid #ebeef5;
}

.card-header i {
  color: #409eff;
  font-size: 15px;
}

.card-body {
  padding: 20px;
}

/* 基本信息样式 */
.info-item {
  display: flex;
  margin-bottom: 12px;
  line-height: 1.5;
  font-size: 14px;
}

.info-label {
  width: 90px;
  color: #606266;
  flex-shrink: 0;
}

.info-value {
  flex: 1;
  color: #303133;
  position: relative;
  cursor: pointer;
}

.info-value:hover .copy-icon {
  opacity: 1;
}

.copy-icon {
  margin-left: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #909399;
  font-size: 13px;
}

.info-item.full {
  flex-direction: column;
}

.info-item.full .info-label {
  width: auto;
  margin-bottom: 4px;
}

/* 产品表格样式 */
.product-table {
  font-size: 14px;
}

.product-table :deep(.el-table__cell) {
  padding: 8px 0;
}

.product-table :deep(.el-table__header th) {
  background-color: #fafafa;
  color: #606266;
  font-weight: 500;
  font-size: 14px;
}

.product-table :deep(.el-table__body td) {
  font-size: 14px;
  color: #303133;
}

.table-summary {
  display: flex;
  justify-content: flex-end;
  gap: 30px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.summary-item {
  font-size: 14px;
  color: #606266;
}

.summary-item.primary {
  color: #f56c6c;
  font-weight: 600;
}

/* 收款凭证样式 */
.receipt-container {
  margin-top: 8px;
}

.receipt-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.receipt-thumb {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  cursor: pointer;
}

.no-images-message {
  color: #909399;
  font-size: 14px;
  text-align: center;
  padding: 20px;
  background-color: #fafafa;
  border-radius: 4px;
}

/* 审核表单样式 */
.radio-group {
  display: flex;
  gap: 20px;
  margin-bottom: 10px;
}

.radio-group .el-radio {
  margin-right: 0;
}

.form-actions-wrapper {
  margin-top: 10px;
  margin-bottom: -10px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
  gap: 12px;
  margin-bottom: 0;
}

/* 时间线样式 */
.timeline-item-wrapper {
  padding: 10px 14px;
  border-radius: 4px;
  margin-bottom: 10px;
  background-color: #fafafa;
}

.timeline-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.timeline-time {
  font-size: 13px;
  color: #606266;
}

.timeline-content {
  color: #303133;
  font-size: 13px;
  line-height: 1.5;
}

/* 审核记录卡片样式优化 */
.timeline-card {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);
  background: #fff;
}

.timeline-body {
  padding: 16px 0;
}

.audit-timeline {
  padding: 0 20px;
}

.timeline-item {
  padding-bottom: 20px;
}

.timeline-item:last-child {
  padding-bottom: 0;
}

.timeline-item-wrapper {
  padding: 16px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #ebeef5;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  margin-left: 4px;
}

.timeline-item-wrapper:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #dcdfe6;
}

.timeline-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f2f5;
}

.timeline-time {
  font-size: 13px;
  color: #8492a6;
  font-weight: 500;
}

.timeline-tag {
  font-weight: 500;
}

.timeline-content {
  color: #5a6a85;
  font-size: 14px;
  line-height: 1.6;
  padding: 4px 0;
}

/* 空状态样式 */
.empty-timeline {
  text-align: center;
  padding: 40px 20px;
  color: #909399;
}

.empty-timeline i {
  font-size: 24px;
  margin-bottom: 8px;
  color: #c0c4cc;
}

.empty-timeline span {
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// examine.vue?c64e2dc0